__turbopack_context__.v({
  "colorD20": "ReviewSubjectLink-module-scss-module__fbEMmq__colorD20",
});
